var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "show": !!_vm.errorMessage,
      "fade": "",
      "variant": _vm.errorVariant
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _c('b-input', {
    key: _vm.isProcessing /*For re-triggering the autofocus*/,
    ref: "valueInput",
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Barcode",
      "required": "",
      "autofocus": "",
      "autocomplete": "off",
      "disabled": _vm.isProcessing
    },
    model: {
      value: _vm.scanValue,
      callback: function ($$v) {
        _vm.scanValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "scanValue"
    }
  }), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.isProcessing
    }
  }, [!_vm.isProcessing ? _c('span', [_vm._v("Scan")]) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }